import { ReactElement, RefObject } from 'react';
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormClearErrors,
  UseFormRegister,
  UseFormReset,
} from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';

import { RecaptchaSize } from '../../types';
import { PageSectionFormField } from '../../ContentfulTypes';

export enum FormFieldInputType {
  EMAIL = 'email',
  TEL = 'tel',
  INPUT = 'input',
  SUBMIT = 'submit',
  CHECKBOX = 'checkbox',
}

export enum FormFieldType {
  TEXTFIELD = 'textfield',
  CHECKBOX = 'checkbox',
  RECAPTCHA = 'recaptcha',
  SUBMIT = 'submit',
  SECTION_HEADING = 'section_heading',
  DROPDOWN = 'dropdown',
}

export enum FormFieldCssClassType {
  HALF = 'half',
  OPTIN = 'optIn',
  RECAPTCHA = 'recaptcha',
  SUBMIT = 'submit',
}

export enum FieldType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  TEXT = 'TEXT',
  CHECKBOX = 'CHECKBOX',
  DROPDOWN = 'DROPDOWN',
  RECAPTCHA = 'RECAPTCHA',
  ERROR = 'ERROR',
}

export interface FormFieldI extends PageSectionFormField {
  inputType?: FormFieldInputType;
  maxLength?: number;
  minLength?: number;
  type?: FormFieldType;
  className?: FormFieldCssClassType;
  showError?: boolean;
  schemaName?: string;
  fieldValues?: string[];
}

export interface FormFieldSectionHeadingI {
  type: FormFieldType;
  heading: Record<string, any>;
}

export type FormFieldT = FormFieldI | FormFieldSectionHeadingI;

export interface FormLayoutProps {
  formFields: FormFieldT[];
  stage: string;
  clearErrors: UseFormClearErrors<FieldValues>;
  resubmitForm: () => void;
  submitForm: (e) => void;
  register: UseFormRegister<FieldValues>;
  control: Control<FieldValues, any>;
  recaptchaRef: RefObject<ReCAPTCHA>;
  recaptchaSize?: RecaptchaSize;
  errors: FieldErrors<FieldValues>;
  touchedFields: any;
  reset: UseFormReset<FieldValues>;
  isValid: boolean;
  loading?: boolean;
  generalError?: Record<string, any>;
  conflictError?: Record<string, any>;
  error?: string;
  successSection?: Record<string, any>;
  testId?: string;
  renderSuccessCta?: () => ReactElement;
  onDropdownChange?: (...args: any[]) => any;
  dropdownData?: Record<string, string>;
  activeDropdown?: string;
  setActiveDropdown?: (...args: any[]) => any;
  preselectedValues?: URLSearchParams;
}

export type FormData = Record<string, string | boolean | Record<string, string>> | undefined;
